import type { ReactNode } from 'react';

export const symbol_right_panel_close: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M297-380q0 9.92 9.5 13.46Q316-363 323-370l89-89q9-9 9-21t-9-21l-89-89q-7-7-16.5-3.46T297-580v200ZM180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm453-60h147v-600H633v600Zm-60 0v-600H180v600h393Zm60 0h147-147Z"
		/>
	</svg>
);
